import { render, staticRenderFns } from "./performance-desc.vue?vue&type=template&id=b859960a&scoped=true"
import script from "./performance-desc.vue?vue&type=script&lang=ts"
export * from "./performance-desc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b859960a",
  null
  
)

export default component.exports